import '../css/app.scss';

import Cursor from './components/cursor';
import ClickTarget from './components/clickTarget';
import KachelSlider from './components/kachelSlider';
import Header from './components/header';
import Burger from './components/burger';
import SpSuperMarquee from 'sp-supermarquee';
import Map from './components/map'; 
import Scroll from './components/scroll';
import Video from './components/video';
import PhotoSlider from './components/photoSlider';
import Movie from './components/movie';



  


/** Global Components */

/** Bootstrap */
$(() => {
  // init global components
  window._cursor = new Cursor($('[data-cursor="el"]'));

  const $clickTargets = $('a[href], [data-click-target], button');

  if ($clickTargets.length) {
    $clickTargets.each((i, el) => {
      new ClickTarget($(el));
    });
  }

// header
const $header = $('[data-header="el"]');
const header = new Header($header); // store reference

// burger (pass header instance into it)
const $burger = $('[data-burger="el"]');
new Burger($burger, header);


  // Kachel Slider
  const $kachelSlider = $('[data-kachelSlider="el"]');
  if ($kachelSlider) {
    new KachelSlider($kachelSlider);
  }

  // Fotobuch
  const $photoSlider = $('[data-photoSlider="el"]');
  if ($photoSlider) {
    new PhotoSlider($photoSlider);
  }

  // SuperMarquee
  const marqueeElement = document.querySelector('.supermarquee');
  if (marqueeElement) {
    const mySuperMarquee = new SpSuperMarquee(marqueeElement);
    mySuperMarquee.setScrollSpeed("medium");

    marqueeElement.addEventListener("mouseenter", function() {
      mySuperMarquee.setScrollSpeed("superslow");
    });

    marqueeElement.addEventListener("mouseleave", function() {
      mySuperMarquee.setScrollSpeed("medium");
    });

    const $_clickTargets = $(marqueeElement).find('a[href], [data-click-target]');

    if ($_clickTargets.length) {
      $_clickTargets.each((i, el) => {
        new ClickTarget($(el));
      });
    }
  }

  // GSAP Animation
  const $scrollImages = $('[data-scroll="image"]');
  const $fadeIn = $('[data-scroll="fade-in"]');
  new Scroll($fadeIn, $scrollImages);

  // Video
  const $video = $('[data-video="el"]');
  $('video').on('pause', function () {
  console.warn('Video paused:', this, new Error().stack);
});


  if ($video.length) {
    $video.each((i, el) => {
      new Video($(el));
    });
  }

  
  // Movie

  const $movie = $('[data-movie="el"]');
  if ($movie) {
    if(window.matchMedia('(pointer: coarse)').matches){
    new Movie($movie);
  }
}

  //Map

  const $map = $('[data-map="el"]');
  if($map){
    new Map($map);
  }




});

function initialize() {
	const fenway = { lat: 46.9937373, lng: 8.6049104 };
	const map = new google.maps.Map(document.getElementById("map"), {
	  center: fenway,
	  zoom: 14,
	});
	const panorama = new google.maps.StreetViewPanorama(
	  document.getElementById("pano"),
	  {
		position: fenway,
		pov: {
		  heading: 34,
		  pitch: 10,
		},
	  },
	);
  
	map.setStreetView(panorama);
  }
  
  window.initialize = initialize;
